import React from 'react';

const GreenButton = ({ children, handleClick, noMargin, submit }) => {
  return submit ? (
    <button
      className={!noMargin ? 'global-btn' : 'global-btn no-margin'}
      type='submit'
    >
      {children}
    </button>
  ) : (
    <button
      onClick={(e) => handleClick(e)}
      className={!noMargin ? 'global-btn' : 'global-btn no-margin'}
    >
      {children}
    </button>
  );
};

export default GreenButton;
